import React, { useState, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { Button } from "@mui/material";
import { MdOutlineSaveAlt } from "react-icons/md";

const ReportList = ({ reports, filteredReports, currentItems }) => {
  const tableRef = useRef(null);
  const [openModal, setOpenModal] = useState(false);
  const [remark, setRemark] = useState("");
  const [selectedReport, setSelectedReport] = useState(null);
  const handleSelectReport = (report) => {
    setSelectedReport(report);
    setRemark("");
    setOpenModal(true);
  };

  const formatDateTime = (dateTime) => {
    const date = new Date(dateTime);
    const formattedDate = date.toLocaleDateString();
    const formattedTime = date.toLocaleTimeString();
    return { formattedDate, formattedTime };
  };

  const processedReports = currentItems.map((report) => {
    const { formattedDate, formattedTime } = formatDateTime(report.dateTime);
    return { ...report, formattedDate, formattedTime };
  });
  const handleExportExcel = () => {
    const excelData = processedReports.map((report, index) => ({
      "#": index + 1,
      "Customer Name": `${report.firstName} ${report.lastName}`,
      "Shared Number": report.referralMobile,
      "Product Name": report.productName,
      "Claim Balance": report.claimBalance,
      "Date": report.formattedDate,
      "Time": report.formattedTime,
      "Status": report.remarks === "verified" ? "Verified" : report.remarks,
    }));

    const headers = [
      "#",
      "Customer Name",
      "Shared Number",
      "Product Name",
      "Claim Balance",
      "Date",
      "Time",
      "Status",
    ];


  };
  return (
    <div>
      <div className="mb-4 mt-2 flex justify-end">
        <DownloadTableExcel
          filename="report"
          sheet="report"
          currentTableRef={tableRef.current}
        >
          <Button
            variant="contained"
            color="primary"
            startIcon={<MdOutlineSaveAlt />}
            onClick={handleExportExcel}
          >
            Download Excel
          </Button>
        </DownloadTableExcel>
      </div>
      <div className="overflow-x-auto">

      <table className="min-w-full divide-y divide-gray-200" ref={tableRef}>
        <thead className="bg-gray-50">
          <tr>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              #
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Customer Name
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Shared Number
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Product Name
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Claim Balance
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Date
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Time
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Status
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {processedReports.map((report, index) => {
            return (
              <tr key={index}>
                <td className="px-4 py-4 whitespace-nowrap">{index + 1}</td>
                <td className="px-4 py-4 whitespace-nowrap">
                  {report.firstName} {report.lastName}
                </td>
                <td className="px-4 py-4 whitespace-nowrap">
                  {report.referralMobile}
                </td>
                <td className="px-4 py-4 whitespace-nowrap">
                  {report.productName}
                </td>
                <td className="px-4 py-4 whitespace-nowrap">
                  {report.claimBalance}
                </td>
                <td className="px-4 py-4 whitespace-nowrap">
                  {report.formattedDate}
                </td>
                <td className="px-4 py-4 whitespace-nowrap">
                  {report.formattedTime}
                </td>
                <td className="px-4 py-4 whitespace-nowrap">
                  {report.remarks === "verified" ? (
                    <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs">
                      Verified
                    </span>
                  ) : (
                    <span className="bg-red-100 text-red-800 px-2 py-1 rounded-full text-xs">
                      {report.remarks}
                    </span>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      </div>
    </div>
  );
};

export default ReportList;
